import '../../less/account-controls.less';
import React, { Component } from 'react';
import { Row, Col, Icon, Popover } from 'antd';
import AccountControlsManager from './AccountControlsManager';
import AccountModal from './AccountModal';
import AccountPopover from './AccountPopover';

// [ARGS]
// trigger | string | passthrough to Popover.trigger (See Ant API)
// profile | string
// type    | string
// content | string OR React Node
// shape   | string
//
// Example:
// <AccountControls
//     trigger='click'
//     profile='analyst'
//     type='analyst:word'
//     content='user'
//     shape='square'
// />

class Type extends Component {
    constructor(props) { super(props); }
    render() {
        let
        c = null,
        { type, content, useStyle } = this.props;
        useStyle = !useStyle;

        switch(type) {
            default: return null;

            case 'custom':
                c = value;
                break;

            case 'analyst:letter':
                c = 'A';
                break;

            case 'analyst:word':
                c = (
                    <div className='ss-cmpts-avatar-word'  style={{ fontSize: '9px' }}>
                        {'Analyst'}
                    </div>
                );
                break;

            case 'admin':
                c = (
                    <div className='ss-cmpts-avatar-word' style={{ fontSize: '10px' }}>
                        {'Admin'}
                    </div>
                );
                break;

            case 'icon':
                c = <Icon type={content} />;
                break;
        }

        return !useStyle ? c : (
            <div className='ss-components-avatar-icon'>
                {c}
            </div>
        );
    }
}

export default class AccountControls extends AccountControlsManager {
    constructor(props) { super(props); }

    render() {
        const
        { type, content, trigger, shape } = this.props,
        accountProps = {...this.props,
            trigger: trigger || 'hover',
            state: this.state,
            services: this.services
        };

        return (
            <div className='ss-cmpts-acct-ctrl-container'>
                <AccountModal {...accountProps} />
                <Popover
                    trigger={accountProps.trigger}
                    placement='bottomLeft'
                    content={<AccountPopover {...accountProps} />}
                >
                    <div
                        className={`ss-cmpts-avatar-outer-${shape == null ? 'circle' : shape}`}
                        style={{ cursor: trigger === 'click' ? 'pointer' : 'default' }}
                    >
                        <div className='ss-cmpts-avatar-icon'>
                            <Type {...this.props} />
                        </div>
                    </div>
                </Popover>
            </div>
        );
    }
}
